import { atom } from 'jotai';
import { IContact } from 'types';

// TODO_R: [FAR]
export const contactsAtom = atom<IContact[]>([]);
